module.exports = __webpack_public_path__ + "static/media/account icon.ec0a7806.svg";